import classnames from 'classnames';
import React, { Component, ReactNode } from 'react';
import ReactDOM from 'react-dom';

const CSS = require('./Overlay.module.scss');

interface OverlayProps {
  portalId: string;
  onEsc: () => void;
  className?: string;
  onClick: (event: any) => void;
  children: ReactNode;
}

class Overlay extends Component<OverlayProps> {
  private portalElement: HTMLElement;

  constructor(props) {
    super(props);
    let portalElement =
      this.props.portalId && document.getElementById(this.props.portalId);
    if (!portalElement) {
      portalElement = document.createElement('div');
      portalElement.id = this.props.portalId;
    }
    this.portalElement = portalElement;
  }

  componentDidMount() {
    document.addEventListener('keydown', this.onKeyUp);
    document.body.style.top = `-${document.scrollingElement.scrollTop}px`;
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.minHeight = '100%';
    document
      .getElementById('reactContainer')
      .setAttribute('aria-hidden', 'true');
    document
      .getElementById('overlay-container')
      .appendChild(this.portalElement);
  }

  componentWillUnmount() {
    const overlayContainer = document.getElementById('overlay-container');
    if (
      overlayContainer &&
      this.portalElement.parentElement === overlayContainer
    ) {
      overlayContainer.removeChild(this.portalElement);
    }
    document.removeEventListener('keydown', this.onKeyUp);
    document.body.removeAttribute('style');
    document
      .getElementById('reactContainer')
      .setAttribute('aria-hidden', 'false');
  }

  onKeyUp = (event) => {
    if (event.key === 'Escape') {
      this.props.onEsc();
    }
  };

  render() {
    const { portalId, onEsc, onClick, ...rest } = this.props;
    const classes = classnames(CSS.Overlay, {
      [this.props.className]: this.props.className,
    });

    return ReactDOM.createPortal(
      <div {...rest} onClick={onClick} className={classes}>
        {this.props.children}
      </div>,
      this.portalElement,
    );
  }
}

export default Overlay;
